// routes
import { PATH_AUTH, PATH_DOCS, PATH_PAGE } from '../../../routes/paths';
// config
import { PATH_AFTER_LOGIN } from '../../../config-global';
// components
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const navConfig = [
  {
    title: 'Beranda',
    icon: <Iconify icon="eva:home-fill" />,
    path: '/',
  },
  {
    title: 'Lowongan Pekerjaan',
    icon: <Iconify icon="ic:round-grain" />,
    path: PATH_PAGE.joblist,
  },  
  {
    title: 'Kontak',
    icon: <Iconify icon="eva:book-open-fill" />,
    path: PATH_PAGE.contact,
  },
];

export default navConfig;
